/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />

namespace Nobox {

    import fld = Administration.UserRow.Fields;

    @Serenity.Decorators.registerClass()
    export class UserAgentGrid extends NoboxEntityGrid<Administration.UserRow, any> {
        //protected getDialogType() { return Nobox.Administration.UserDialog; }
        protected getColumnsKey() { return DivisionAgentColumns.columnsKey; }
        protected getIdProperty() { return Administration.UserRow.idProperty; }
        protected getLocalTextPrefix() { return Administration.UserRow.localTextPrefix; }
        protected getService() { return Administration.UserService.baseUrl; }

        constructor(container: JQuery) {
            super(container); 
        }

        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);
            Serenity.SubDialogHelper.cascade(dialog, this.element.closest('.ui-dialog'));
        }

        protected addButtonClick() {
            this.editItem({ ListId: this.listId });
        }

        protected getButtons() {
            var buttons = super.getButtons();
            var $this = this;
            buttons.splice(0, 1);
            return buttons;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.listId;
        }

        private _ListID: string;

        get listId() {
            return this._ListID;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Administration.UserListRequest;
            ////request.ColumnSelection = 1;
            //request.IncludeColumns = ["DisplayName", "Email", "Ctry", "States", "City", "LastLogin"];
            request.EqualityFilter = { Roles: ["3"] };
            ////request.ColumnSelection = 1;
            //request.Criteria = Serenity.Criteria.and(request.Criteria, [[fld.DivisionIds], 'like', '%' + this.listId + '%']); return true;
        }
        set listId(value: string) {
            if (this._ListID !== value) {
                this._ListID = value;
                this.refresh();
            }
        }
    }
}